export const FontIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" fill="none" viewBox="0 0 18 20" className="stroke-black dark:stroke-white">
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 3.466V1h16v2.466M9 1v18M5 19h8"
            ></path>
        </svg>
    );
};
